export default __webpack_public_path__ + "static/media/createCollections.e82c7f03.png";